import React, { useState } from "react";
import "./RecommendationCreateForm.css";

function RecommendationCreateForm({ onClose, onSave }) {
  const [heading, setHeading] = useState("");
  const [text, setText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!heading || !text) {
      alert("Both heading and text are required.");
      return;
    }
    onSave({ heading, text });
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h3>Create Recommendation</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Recommendation Heading:
            <input
              name="heading"
              value={heading}
              onChange={(e) => setHeading(e.target.value)}
              required
              placeholder="Enter recommendation heading"
            />
          </label>
          <label>
            Recommendation Text:
            <textarea
              name="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              required
              rows={12}
              placeholder="Enter recommendation details"
            />
          </label>
          <div className="modal-buttons">
            <button className="blue-button" type="submit">
              Create
            </button>
            <button className="red-button" type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RecommendationCreateForm;
